import {Component, Input, OnInit} from '@angular/core';
import {FullUser} from '../../../model';

@Component({
  selector: 'app-user-portfolio-one-container',
  templateUrl: './user-portfolio-one-container.component.html',
  styleUrls: ['./user-portfolio-one-container.component.css']
})
export class UserPortfolioOneContainerComponent implements OnInit {

  @Input() user: FullUser;
  constructor() { }

  ngOnInit() {
  }

}
